import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';

export default class PropertyTypeFilters extends React.Component {
  static propTypes = {
    assetClasses: PropTypes.array.isRequired,
    embedded: PropTypes.bool,
    selectedAssetClasses: PropTypes.array.isRequired,
    onAssetClassChange: PropTypes.func.isRequired,
  };

  handleAssetClassChange = (e, assetClass) => {
    const { selectedAssetClasses, onAssetClassChange } = this.props;
    const selectedSubclasses = assetClass.subclasses.filter(sc => selectedAssetClasses.includes(sc.value)
    );
    const { checked } = e.target;
    if (selectedSubclasses.length > 0) {
      if (!checked) {
        selectedSubclasses.forEach((subclass) => {
          onAssetClassChange({
            target: { value: subclass.value, checked: false },
          });
        });
      }
    }
    onAssetClassChange(e);
  };

  renderCheckboxGroup = (assetClass) => {
    const subclassOptionIds = assetClass.subclasses.map(c => c.value);
    const selectedSubclasses = this.props.selectedAssetClasses.filter(c => subclassOptionIds.includes(c)
    );

    return (
      <div key={assetClass.value}>
        <div>
          <FilterCheckboxGroup
            className=""
            options={[assetClass]}
            selected={this.props.selectedAssetClasses}
            onChange={e => this.handleAssetClassChange(e, assetClass)}
          />
          {assetClass.hint && (
            <small className="text-muted">{assetClass.hint}</small>
          )}
        </div>
        {this.props.selectedAssetClasses.includes(assetClass.value) && (
          <div className="ms-5">
            <FilterCheckboxGroup
              checkAllIfNone={true}
              className="pb-2"
              options={assetClass.subclasses}
              selected={selectedSubclasses}
              onChange={this.props.onAssetClassChange}
            />
          </div>
        )}
      </div>
    );
  };

  render() {
    const { assetClasses, embedded } = this.props;
    return (
      <div className={classNames({ 'd-none d-md-block': !embedded })}>
        {!embedded && (
          <h6 className="fw-semibold fs-large pb-1 border-bottom">
            Property Type
          </h6>
        )}
        <div className="mt-2">{assetClasses.map(this.renderCheckboxGroup)}</div>
      </div>
    );
  }
}
